<template>
  <div>
    <v-app-bar color="light-blue darken-2" dense dark app>
      <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon>-->
      <v-toolbar-title>
        <v-btn
          color="light-blue darken-2"
          elevation="0"
          @click="home()"
          style="font-size: 1.25rem"
        >
          <v-icon class="mr-2">mdi-home</v-icon>{{this.$AppName.CoLtdMenuBarFull}}
        </v-btn>
        <!-- <v-icon class="mr-2 mb-1">mdi-home</v-icon>{{this.$AppName.CoLtdMenuBarFull}} -->
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn color="light-blue darken-2" elevation="0" @click="dashboard()">
        <v-icon class="mr-2">mdi-monitor-dashboard</v-icon>รายงานภาพรวม
      </v-btn>
      <v-btn color="light-blue darken-2" elevation="0" @click="signIn()">
        <v-icon class="mr-2">mdi-account-key</v-icon>เข้าสู่ระบบ
      </v-btn>
      <v-btn color="light-blue darken-2" elevation="0" @click="register()">
        <v-icon class="mr-2">mdi-account-plus-outline</v-icon>ลงทะเบียนลูกค้า
      </v-btn>

      <!-- <v-btn icon>
        <v-icon>mdi-heart</v-icon>
      </v-btn>

      -->

      <!-- <v-menu
        left
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="n in 5"
            :key="n"
            @click="() => {}"
          >
            <v-list-item-title>Option {{ n }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>-->
    </v-app-bar>
    <br />
  </div>
</template>

<script>
export default {
  name: "menuBar",
  data() {
    return {};
  },
  methods: {
    home() {
      this.$router.push({ path: "/" });
    },
    signIn() {
      this.$router.push({ path: "/signin" });
    },
    register() {
      this.$router.push({ path: "/register" });

    },
    dashboard() {
      this.$router.push({ path: "/fdashboard" });

    },
  },
};
</script>
